import React from 'react';
import DocumentHeader from '../../components/DocumentHeader';
import DynamicHeroIcon from '../../components/DynamicHeroIcons';

import certificates from '../../constants/certificates';
import {getBrandName} from '../../components/Brand';

const CertificatePage = ({slug}) => {
  const certificate = certificates[slug];

  return (
    <div className="relative bg-gray-50 overflow-hidden">
      <DocumentHeader
        title={`${slug} Completion Certificate`}
      />
      <div className="relative pt-6 pb-16 sm:pb-24">
        <main className="mt-16 mx-auto max-w-7xl px-4 sm:mt-24">
          <div className="text-center">
            <h1 className="text-2xl tracking-tight font-extrabold text-gray-900 sm:text-3xl md:text-4xl">
              {`Certificate of Completion for ${getBrandName()}’s`}
            </h1>
            <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
              <span className="text-indigo">{certificate.name}</span>
            </h1>
            {certificate.description && (
            <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
              {certificate.description}
            </p>
            )}
          </div>
        </main>

        <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 space-y-12 md:space-y-32">
          <dl className="space-y-10 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8">
            {certificate.objectives.map((objective) => (
              <div key={objective.name}>
                <dt>
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                    <DynamicHeroIcon name={objective.icon} className="h-6 w-6" />
                  </div>
                  <p className="mt-5 text-lg leading-6 font-medium text-gray-900">{objective.name}</p>
                </dt>
                <dd className="mt-2 text-base text-gray-500">{objective.description}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
};

export default CertificatePage;
